import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import config from '@ers/config';
// polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// extenders
import '@ers/extenders/object';
import '@ers/extenders/string';
import '@ers/extenders/array';
import '@ers/extenders/date';

import './assets/styles/style.less';
import App from './App';

const { beforeSendSentry } = require('@ers/errors/');

if (config.sentry) {
    const cfg = { ...config.sentry,
        beforeSend: beforeSendSentry };
    Sentry.init(cfg);
}
ReactDOM.render(<App />, document.getElementById('root'));
